import React, {useRef, useState} from 'react';
import Box from "@mui/material/Box";
import "../../Common.css"
import {contentTexts} from "../ContentText.js";
import "./CoachingAppointment.css"
import {
    FormControl, FormControlLabel, Grid, TextField, Checkbox, Link, CircularProgress
} from "@mui/material";
import {HorizontalLineSecondary} from "../Components/HorizontalLine/HorizontalLinePrimary";
import PrimaryButton from "../Components/Buttons/PrimaryButton";
import {defaultColors} from "../ColorSchema";
import SubTitle from "../Components/SubTitle";
import TopTitle from "../Components/TopTitle";
import SendScreen from "../Components/SendScreen";
import axios from "axios";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";


function CoachingAppointment(props) {
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [phonenumber, setPhonenumber] = useState("");
    const [goals, setGoals] = useState("");
    const [agb, setAgb] = useState(false);
    const [datenschutz, setDatenschutz] = useState(false);

    const [errorPhone, setErrorPhone] = useState(false);
    const [errorEmail, setErrorEmail] = useState(false);

    const [formSend, setFormSend] = useState(false)
    const [formHeight, setFormHeight] = useState(0)
    const [formWidth, setFormWidth] = useState(0)
    const formRef = useRef(null)

    const [loading, setLoading] = useState(false)


    function handlePhoneChange(e) {
        setPhonenumber(e.target.value)
        if (isNotValidPhoneNumber(e.target.value)) {
            setErrorPhone(true)
        } else {
            setErrorPhone(false)
        }
    }

    function handleEmailChange(e) {
        setEmail(e.target.value)
        if (emailValidator(e.target.value)) {
            setErrorEmail(true)
        } else {
            setErrorEmail(false)
        }
    }

    const emailValidator = value => {
        return !/^[a-zA-Z0-9._:$!%-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]+$/.test(value);

    };

    const isNotValidPhoneNumber = (number) => {
        const phoneRegex = /^\+?[0-9]{7,15}$/;
        return !phoneRegex.test(number);
    };

    const submitForm = (e) => {
        e.preventDefault();
        // only submit if both are checked, otherwise you could disable the button

        let message = "Name: " + name + "\n" + "Email: " + email + "\n" + "Phonenumber: " + phonenumber + "\n" + "Goals: " + goals + "\n";

        setLoading(true)
        axios.post('https://api.smart-physique.at/api/Email/send/chappa', {
            From: email.trim(),
            To: 'info@smart-physique.at',
            Subject: 'New Customer Appointment Request',
            Body: message
        })
            .then(function (response) {
                setFormHeight(formRef.current.clientHeight)
                setFormWidth(formRef.current.clientWidth)
                setFormSend(true)
            })
            .catch(function (error) {
                setErrorEmail(true)
            }).finally(function (){
                setLoading(false)
        });


    };

    let sendable = name !== "" && email !== "" && phonenumber !== "" && agb && datenschutz && !errorPhone && !errorEmail && !loading;

    return (<Box className={"flexRowCenter coaching_appointment_content"} sx={{
        flexDirection: {xs: 'column', md: 'row'}, display: "flex", justifyContent: "center", alignItems: "center",
    }} ref={props.refs}>
        <Box className={"appointment_container text_container "} sx={{width: {xs: "100%", md: "50%"}}}>
            <TopTitle
                sx={{color: defaultColors.surface_container_highest}}>{contentTexts.coachingAppointmentTitle}</TopTitle>
            <SubTitle
                sx={{color: defaultColors.surface_container_highest}}>{contentTexts.coachingAppointmentSubtitle}</SubTitle>
            <HorizontalLineSecondary className={"font_margin"}/>
            <p className={"content_font_appointment"}>{contentTexts.coachingAppointmentContent}</p>
        </Box>

        <Box className={"flexRowCenter appointment_container form_container"} sx={{width: {xs: "100%", md: "50%"}}}>
            <Box className={"flexColumnCenter"}
                 ref={formRef}
                 sx={{
                     backgroundColor: defaultColors.surface,
                     borderRadius: '24px',
                     padding: '16px',
                     maxWidth: '580px',
                     boxShadow: 2,
                     height: formSend ? formHeight : "auto",
                     width: formSend ? formWidth : '100%'
                 }}>

                {formSend ? (
                    <SendScreen invert={true}/>
                ) : (
                    <FormControl component="form" onSubmit={submitForm} fullWidth>
                        <Grid container spacing={1} sx={{width: "100%"}}>
                            <Grid item xs={12}>
                                <TextField
                                    label="Name"
                                    value={name}
                                    onChange={e => setName(e.target.value)}
                                    className={"textfield_style"}
                                    size="small"
                                    fullWidth
                                />
                            </Grid>
                            <Grid item xs={8}>
                                <TextField
                                    label="E-Mail"
                                    name="email"
                                    value={email}
                                    onChange={handleEmailChange}
                                    className={"textfield_style"}
                                    size="small"
                                    error={errorEmail}
                                    fullWidth
                                />
                            </Grid>
                            <Grid item xs={4}>
                                <TextField
                                    label="Telefonnummer"
                                    name="phone"
                                    value={phonenumber}
                                    onChange={handlePhoneChange}
                                    className={"textfield_style"}
                                    size="small"
                                    error={errorPhone}
                                    fullWidth
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    rows={8}
                                    multiline
                                    value={goals}
                                    onChange={e => setGoals(e.target.value)}
                                    label="Nachricht / Ziele"
                                    className={"textfield_style"}
                                    size="small"
                                    fullWidth
                                />
                            </Grid>

                            {/* AGB & Widerrufsrecht */}
                            <Grid item xs={12}>
                                <FormControlLabel
                                    control={<Checkbox
                                        checked={agb}
                                        onChange={e => setAgb(e.target.checked)}
                                        sx={{color: defaultColors.primary}}
                                        className="checkbox_agb_coaching"
                                    />}
                                    label={<span>
                      <Link href="https://app.smart-physique.at/agb" target="_blank" underline="hover">
                        AGB & Widerrufsrecht
                      </Link> {" "}gelesen und akzeptiert.
                    </span>}
                                />
                            </Grid>

                            {/* Datenschutz */}
                            <Grid item xs={12}>
                                <FormControlLabel
                                    control={
                                    <Checkbox
                                        checked={datenschutz}
                                        onChange={e => setDatenschutz(e.target.checked)}
                                        sx={{color: defaultColors.primary}}
                                        className="checkbox_datenschutz_coaching"
                                    />}
                                    label={<span>
                                      <Link href="https://app.smart-physique.at/privacy-policy" target="_blank"
                                            underline="hover">
                                        Datenschutz
                                      </Link>{" "}
                                        gelesen und akzeptiert.
                                    </span>}
                                />
                            </Grid>

                            <Grid item xs={12}>
                                <PrimaryButton
                                    type="submit"
                                    className={"form_button"}
                                    disabled={!sendable}
                                    startIcon={loading ? <CircularProgress size="25px" color="inherit"/> : (<></>)}

                                >
                                    {loading ? "Wird gesendet..." : "Jetzt Termin vereinbaren"}
                                </PrimaryButton>
                            </Grid>
                        </Grid>
                    </FormControl>
                )}
            </Box>
        </Box>
    </Box>);
}

export default CoachingAppointment;
